import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextLabel from '../textLabel';
import compose from '../../hoc/compose';
import { dataHooks } from './constants';

var Badge = function Badge(_ref) {
  var dataHook = _ref.dataHook,
      automationId = _ref.automationId,
      getClassName = _ref.getClassName,
      value = _ref.value,
      skin = _ref.skin,
      uppercase = _ref.uppercase;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook,
    "data-aid": automationId,
    className: classNames(getClassName('control-badge'), "badge-".concat(skin), {
      'to-uppercase': uppercase
    })
  }, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: dataHooks.label,
    type: "T03",
    value: value
  }));
};

Badge.displayName = 'Badge';
Badge.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** content to be displayed */
  value: PropTypes.string,

  /** changing the look of the component */
  skin: PropTypes.oneOf(['standard', 'premium', 'attention', 'success', 'alert', 'urgent', 'general']),

  /** forces uppercase letters */
  uppercase: PropTypes.bool
};
Badge.defaultProps = {
  value: '',
  skins: 'standard',
  uppercase: false
};
export default compose(Badge);